<div class="saved-filters-dialog">
  <header class="saved-filters-header">
    <h2>{{ dialogTitle }}</h2>
    <button type="button" class="header-close-button" aria-label="Close dialog" (click)="cancel()">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <section class="saved-filters-content">
    <div class="saved-filters-table-shell">
      <div class="saved-filters-toolbar">
        <div class="toolbar-title">{{ tableTitle }}</div>

        <div class="toolbar-filter" *ngIf="showNameFilter">
          <label for="saved-filter-name">Name</label>
          <select id="saved-filter-name" [ngModel]="selectedName" (ngModelChange)="selectName($event)">
            <option value="">Select</option>
            <option *ngFor="let filter of filters" [value]="filter[selectionFieldKey]">{{ filter[selectionFieldKey] }}</option>
          </select>
        </div>

        <button type="button" class="icon-button" *ngIf="showEditAction" aria-label="Delete saved filter">
          <mat-icon>delete</mat-icon>
        </button>
        <button
          type="button"
          class="icon-button"
          *ngIf="showEditAction"
          aria-label="Edit saved filter"
          [disabled]="!selectedFilter"
          (click)="openEditModal()">
          <mat-icon>edit</mat-icon>
        </button>
        <button
          type="button"
          class="icon-button"
          *ngIf="showFilterAction"
          aria-label="Filter saved filters"
          (click)="openSavedFiltersFilterDialog()">
          <mat-icon>filter_list</mat-icon>
        </button>
        <button
          type="button"
          class="icon-button muted"
          *ngIf="showClearFilterAction"
          [class.active]="hasSavedFilterFilterApplied"
          [disabled]="!hasSavedFilterFilterApplied"
          aria-label="Clear saved filter search"
          (click)="clearSavedFiltersFilter()">
          <mat-icon>filter_list_off</mat-icon>
        </button>
      </div>

      <div class="saved-filters-table-viewport">
        <table class="saved-filters-table">
          <thead>
            <tr>
              <th *ngFor="let column of tableColumns; trackBy: trackByColumnKey" (click)="sortColumnByKey(column)">
                {{ column.label }} <span *ngIf="column.sortable !== false" class="sort-icon">&#8597;</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let filter of pagedRows"
              [class.selected]="filter === selectedFilter"
              (click)="selectRow(filter)">
              <td *ngFor="let column of tableColumns; trackBy: trackByColumnKey">{{ filter[column.key] }}</td>
            </tr>
            <tr *ngIf="loading || errorMessage || (!loading && filteredRows.length === 0)" class="status-row">
              <td [attr.colspan]="tableColumns.length">
                <span *ngIf="loading">{{ loadingMessage }}</span>
                <span *ngIf="!loading && errorMessage">{{ errorStateMessage }}</span>
                <span *ngIf="!loading && !errorMessage && filteredRows.length === 0">{{ emptyStateMessage }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>

  <footer class="saved-filters-footer">
    <div class="saved-filters-pagination">
      <span>Rows: {{ filteredRows.length }} | Page Size: {{ pageSize }} | Current Page: {{ currentPage }}</span>

      <div class="pager-controls">
        <button type="button" (click)="goToPage(1)" [disabled]="currentPage === 1">
          <mat-icon>first_page</mat-icon>
        </button>
        <button type="button" (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 1">
          <mat-icon>chevron_left</mat-icon>
        </button>
        <button
          *ngFor="let page of pageNumbers"
          type="button"
          class="page-number"
          [class.active]="page === currentPage"
          (click)="goToPage(page)">
          {{ page }}
        </button>
        <button type="button" (click)="goToPage(currentPage + 1)" [disabled]="currentPage === totalPages">
          <mat-icon>chevron_right</mat-icon>
        </button>
        <button type="button" (click)="goToPage(totalPages)" [disabled]="currentPage === totalPages">
          <mat-icon>last_page</mat-icon>
        </button>
      </div>
    </div>

    <div class="dialog-actions">
      <ng-container *ngIf="showFooterActions">
        <button type="button" class="cancel-button" mat-flat-button (click)="cancel()">Cancel</button>
        <button type="button" class="apply-button" mat-flat-button [disabled]="!selectedFilter" (click)="apply()">{{ applyButtonLabel }}</button>
      </ng-container>
    </div>
  </footer>

  <div class="edit-filter-backdrop" *ngIf="editModalOpen">
    <section class="edit-filter-modal">
      <h3>Edit filter</h3>

      <label class="edit-filter-field">
        <span>Name</span>
        <input type="text" [(ngModel)]="editName" autofocus>
      </label>

      <label class="edit-filter-field">
        <span>Description</span>
        <input type="text" [(ngModel)]="editDescription">
      </label>

      <div class="edit-filter-divider"></div>

      <div class="edit-filter-actions">
        <button type="button" class="cancel-button" mat-flat-button (click)="closeEditModal()" [disabled]="editSaving">Cancel</button>
        <button type="button" class="apply-button" mat-flat-button (click)="saveEdit()" [disabled]="editSaving || !editName.trim()">Save</button>
      </div>
    </section>
  </div>
</div>
